/**
 * CardHeader displays a title and optional subtitle within a card.
 * Supports alignment and size options for flexible presentation.
 * Use in Block Kit Style Cards (see DOCUMENTATION.md) for consistent section headers.
 */
import React from 'react';
import { cn } from '@strivelabs/ui-core';

export interface CardHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  size?: 'sm' | 'md' | 'lg' | 'customXl';
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};

export const titleSizes = {
  sm: 'text-sm font-medium',
  md: 'text-base font-semibold',
  lg: 'text-base font-bold',
  customXl: 'text-[32px] leading-[40px] font-normal'
};

const subtitleSizes = {
  sm: 'text-xs text-muted-foreground',
  md: 'text-sm text-muted-foreground',
  lg: 'text-base text-muted-foreground',
  customXl: 'text-[32px] leading-[40px] font-normal'
};

export const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  subtitle,
  align = 'left',
  size = 'md',
  className,
  titleClassName,
  subtitleClassName
}) => {
  return (
    <div className={cn(alignClasses[align], className)}>
      <h3 className={cn(titleSizes[size], titleClassName)}>
        {title}
      </h3>
      {subtitle && (
        <p className={cn(subtitleSizes[size], 'mt-1', subtitleClassName)}>
          {subtitle}
        </p>
      )}
    </div>
  );
};